module.exports = __webpack_public_path__ + "static/media/terpel.ab1939e1.png";